/*
 * Public API Surface of ccs-ngl-prmrybtn
 */
export * from './lib/ccs-ngl-prmrybtn.component';
export * from './lib/ccs-ngl-prmrybtn.module';